import AppHeader from '../components/AppHeader';
import { useOrg } from '../components/OrgContext';
import { homeKindFor } from '../redesign/company';
import HomeBoard from '../redesign/HomeBoard';
import { L } from '../redesign/tokens';

// The redesigned Home (dev website only: see lib/redesign.js). A pure agent gets Leo's agent board; every other company
// (distributor, manufacturer, agent + manufacturing) gets the distributor board. Staff viewing a company see that company's.
export default function HomeRedesign() {
  const { capabilities } = useOrg();
  return (
    <div style={{ minHeight: '100vh', background: L.bg, color: L.text, fontFamily: L.sans, display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <HomeBoard kind={homeKindFor(capabilities)} />
    </div>
  );
}
